import React from 'react';
import LocationTemplate from './LocationTemplate';

const HarrellsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Harrells"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28444"]}
      latitude={34.7365}
      longitude={-78.1469}
      population={184}
      historicalFact="Named after the Harrell family, early settlers who established a trading post in the area."
      nearbyTowns={[
        "Clinton, NC",
        "Warsaw, NC",
        "Rose Hill, NC",
        "Turkey, NC",
        "Garland, NC",
        "Salemburg, NC",
        "Newton Grove, NC",
        "Kenansville, NC"
      ]}
    />
  );
};

export default HarrellsPage;